import { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { fetchFromApi } from '@utils/apiOrigin'
import { LoadingSpinner } from '@components/ui/loading-spinner'

const ADMIN_TOKEN_KEY = 'ecofarte_admin_token'

export function AdminProtectedRoute() {
  const [state, setState] = useState<'loading' | 'ok' | 'no-session' | 'forbidden' | 'expired'>('loading')

  useEffect(() => {
    let cancelled = false

    void (async () => {
      const token = localStorage.getItem(ADMIN_TOKEN_KEY)
      if (!token) {
        if (!cancelled) setState('no-session')
        return
      }

      try {
        const res = await fetchFromApi('/api/admin/verify', {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` }
        })

        if (cancelled) return

        if (res.status === 401) {
          localStorage.removeItem(ADMIN_TOKEN_KEY)
          localStorage.removeItem('ecofarte_admin_session')
          setState('expired')
          return
        }

        if (res.status === 403) {
          localStorage.removeItem(ADMIN_TOKEN_KEY)
          localStorage.removeItem('ecofarte_admin_session')
          setState('forbidden')
          return
        }

        if (!res.ok) {
          localStorage.removeItem(ADMIN_TOKEN_KEY)
          localStorage.removeItem('ecofarte_admin_session')
          setState('no-session')
          return
        }

        setState('ok')
      } catch {
        if (!cancelled) setState('no-session')
      }
    })()

    return () => {
      cancelled = true
    }
  }, [])

  if (state === 'loading') {
    return <LoadingSpinner fullScreen />
  }

  if (state === 'no-session') {
    return <Navigate to="/admin" replace />
  }

  if (state === 'forbidden') {
    return <Navigate to="/admin" replace state={{ adminError: 'forbidden' }} />
  }

  if (state === 'expired') {
    return <Navigate to="/admin" replace state={{ adminError: 'expired' }} />
  }

  return <Outlet />
}
